import './barnatvilla/style';
import FormStructure from './barnatvilla/form_structure';

export default FormStructure;